export default "__VITE_ASSET__DBF5MFeJ__"